(function() {
    'use strict';

    angular
        .module('core')
        .filter('parseUtilityClasses', () =>
        (classes, prefix) => classes && classes.map(i => `${prefix}--${i}`).join(' ')
        );
})();
